// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bgz_a bho_h","Menu__offsetParent":"bgz_b bho_bj","Menu__trigger--shadowed":"bgz_c"};